"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = Loading;

var _styledTools = require("styled-tools");

var _circles = _interopRequireDefault(require("./circles"));

var _react = _interopRequireDefault(require("react"));

var _spinner = _interopRequireDefault(require("./spinner"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["active", "className", "relative", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Get loader component.
 */
function getLoaderComponent(type) {
  switch (type) {
    case 'circles':
      return _circles["default"];

    default:
      return _spinner["default"];
  }
}
/**
 * `Wrapper` styled component.
 */


var Wrapper = _styledComponents["default"].span.withConfig({
  displayName: "loading__Wrapper",
  componentId: "sc-rj2mm5-0"
})(["display:inline-block;opacity:", ";transition:opacity ", ";", ""], (0, _styledTools.ifProp)('active', 1, 0), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifNotProp)('relative', (0, _styledComponents.css)(["left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);"])));
/**
 * Export `Loading` component.
 */


function Loading(props) {
  var active = props.active,
      className = props.className,
      relative = props.relative,
      type = props.type,
      rest = _objectWithoutProperties(props, _excluded);

  var Loader = getLoaderComponent(type);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    active: active,
    className: className,
    relative: relative
  }, /*#__PURE__*/_react["default"].createElement(Loader, _extends({
    active: active
  }, rest)));
}
/**
 * Default props.
 */


Loading.defaultProps = {
  type: 'spinner'
};